import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getHomePageContent } from '../../api/home';

export default function useGetHomePageContent(options) {
  const result = useQuery('get-home', () => getHomePageContent(), {
    staleTime: 120 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });

  const formattedResult = useMemo(
    () => ({
      ...result,
      data: result?.data?.data,
    }),
    [result],
  );

  return formattedResult;
}
